import script from "./VerifiedCollectionField.vue?vue&type=script&setup=true&lang=js"
export * from "./VerifiedCollectionField.vue?vue&type=script&setup=true&lang=js"

import "./VerifiedCollectionField.vue?vue&type=style&index=0&id=7b79d280&lang=scss&scoped=true"
script.__scopeId = "data-v-7b79d280"

export default script